import React from "react";
import { FilePart, MessagePart } from "common/utils/chatAgent/types";
import { Icon as LucideIcon } from "../../Common/Icons/LucideIcons";
import {
  FileReferenceContainer,
  FileReferenceItem,
  FileReferenceName,
} from "./__styles__/ChatHistory";

export interface FileReferencesProps {
  parts: MessagePart[];
}

const FileReferences: React.FC<FileReferencesProps> = ({ parts }) => {
  const fileParts = React.useMemo(
    () => parts.filter((p): p is FilePart => p.type === "file"),
    [parts],
  );

  if (fileParts.length === 0) return null;

  return (
    <FileReferenceContainer>
      {fileParts.map((filePart, index) => (
        <FileReferenceItem key={`${filePart.filename || "file"}-${index}`}>
          <LucideIcon iconName="file" color="contentSecondary" size={12} />
          <FileReferenceName title={filePart.filename}>
            {filePart.filename || "Untitled file"}
          </FileReferenceName>
        </FileReferenceItem>
      ))}
    </FileReferenceContainer>
  );
};

export default FileReferences;
